import BaseAction from './BaseAction.js';
import {
    setAllTrackSteps} from 'actions/index.js';
import Track from 'track/Track.js';
import {setSelectedPianoRollSteps} from 'actions/index.js';

let counter=0;

class MoveStepsAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({
        track,
        steps,
        transformation,
        resolution=Track.baseResolution,
        wrap=true,
        isPianoRoll=false},
            updateRedux=true,
            isSyncedOperation=false) {
        let pattern = track.getEasyPattern();
        let stepNumbers = pattern.getStepNumbers(steps, resolution).filter(
            x => x[0]);
        let oldTransposes = new Set(stepNumbers.filter(x => x && x[0]).map(x => x[0].transpose));
        let newSteps = track.getEasyPattern()
            .transformSteps(steps, stepNumbers, transformation, resolution, wrap, isPianoRoll);
        let newTransposes = new Set(newSteps.filter(x => x).map(x => x.transpose));
        if (updateRedux) {
            if (isSyncedOperation) {
                counter++;
                let c = counter;
                setTimeout(() => {
                    if (c === counter) {
                        track.updateSteps(!isPianoRoll, true, resolution.isTriplet);
                    }
                }, 50);
            } else {
                if (isPianoRoll && this.sequencerEngine.state.sequencer.displayResolution.isTriplet) {
                    pattern.update();
                }
                if (!isPianoRoll && !resolution.isTriplet) {
                    track.getEasyPattern().pattern.syncMatrix();
                }
                if (isPianoRoll) {
                    this.updateReduxForRows(oldTransposes, newTransposes, track, resolution.isTriplet);
                } else {
                    track.updateSteps(!isPianoRoll && resolution.isTriplet, true, resolution.isTriplet);
                }
            }
        }
        if (updateRedux && !isSyncedOperation) {
            let selectedSteps = this.sequencerEngine.store.getState().keyboard.selectedPianoRollSteps;
            // make sure the same reference remains
            for (let i in selectedSteps) {
                if (selectedSteps[i]) {
                    let step = newSteps.find(s => s && s.id === selectedSteps[i].id);
                    selectedSteps[i] = step;
                }
            }
            this.sequencerEngine.store.dispatch(setSelectedPianoRollSteps(selectedSteps));
        }
        return {stepNumbers: stepNumbers };
    }

    updateReduxForRows(oldTransposes, newTransposes, track, isTriplet) {
        let trackNumber = track.id;
        let trackPianoRollSteps = {... this.state.tracks.trackPianoRollSteps[trackNumber]};
        let trackPianoRollPositions = {... this.state.tracks.trackPianoRollPositions[trackNumber]}
        let trackPianoRollDurations = {...this.state.tracks.trackPianoRollDurations[trackNumber]};

        let updateAction = track.getEasyPattern().pattern.getUpdateStepsAction(isTriplet);
        let transposes = [... Array.from(oldTransposes), ... Array.from(newTransposes)];
        for (let transpose of transposes) {
            trackPianoRollSteps[transpose] = updateAction.pianoRollSteps[transpose];
            trackPianoRollDurations[transpose] = updateAction.pianoRollDurations[transpose];
            trackPianoRollPositions[transpose] = updateAction.pianoRollPositions[transpose];
        }
        let trackPatternSteps = this.state.tracks.trackPatternSteps[trackNumber] || {};
        trackPatternSteps[track.currentPattern] = updateAction.steps;
        this.sequencerEngine.store.dispatch(
            setAllTrackSteps(
                trackNumber,
                updateAction.steps,
                trackPianoRollSteps,
                updateAction.trackFills,
                updateAction.trackStepIds,
                trackPianoRollPositions,
                trackPianoRollDurations,
                trackPatternSteps,
            ));
    }

    undo(action) {
        let transformation = {... action.payload.transformation};
        transformation.stepDifference = -1 * transformation.stepDifference;
        transformation.transposeDifference = -1 * transformation.transposeDifference;

        this.execute(
            {
                ... action.payload,
                transformation
            });
    }

    async serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        operation.payload.steps = operation.payload.steps
            .filter(x => x)
            .map(x => x.id);
        operation.payload.stepNumbers = operation.payload.stepNumbers
            .filter(([x, y]) => x)
            .map(
                ([stepData, stepNumber]) =>
                    [stepData.id, stepNumber]);
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        let track = payload.track;
        if (track === undefined) {
            return undefined;
        }

        // given these we need to find the steps that match these numbers
        let steps = payload.steps;
        payload.steps = this.getStepsForStepNumbers(steps.map(x => ({id: x})), track, Track.baseResolution);
        return action;
    }

    getContentId(action) {
        return action.payload.steps.map(step => step && step.id);
    }
}

const didStepNumbersChange = (a, b) => {
    console.log(a, b);
}
export default MoveStepsAction;
